export default "__VITE_ASSET__f10f8708__"